import { render, staticRenderFns } from "./PaymentReceivedForm.vue?vue&type=template&id=12d0c456&scoped=true&"
import script from "./PaymentReceivedForm.vue?vue&type=script&scoped=true&lang=js&"
export * from "./PaymentReceivedForm.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./PaymentReceivedForm.vue?vue&type=style&index=0&id=12d0c456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d0c456",
  null
  
)

export default component.exports